import { render, staticRenderFns } from "./RemoteLink.vue?vue&type=template&id=ccedf6ec&"
import script from "./RemoteLink.vue?vue&type=script&lang=js&"
export * from "./RemoteLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports